import DialogComponent from "components/Dialog";

import './themes/default.less';
import './index.less';

export default class TeethDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            children: false,
            selected: [],
            teethId: false,
        };

        this.state = { ...this.defaultState };
    }

    show(children, id, diagnosisTeeth, hideCb) {
        this.hidCb = hideCb;
        this.dialogTitle = `${this._helper.string.capitalize(this.tr("client.tooth"))} ${id}` || this._helper.string.capitalize(this.tr("client.tooth"));
        this.state.children = children;
        this.state.teethId = id;

        this.state.selected = diagnosisTeeth ? diagnosisTeeth.map(it => { return it.id; }) : [];

        super.show();
    }

    save() {
        const { selected, teethId } = this.state;
        const diag = [...this._config.diagnosis.filter(it => selected.includes(it.id))];

        if (diag.length > 3) {
            this.showError("client.error3diagnoses");
        } else {
            if (this.hidCb?.apply)
                this.hidCb({ diag, teethId });

            this.hide();
        }


    }

    onClickOvalText(id) {
        const { selected } = this.state;
        if (selected.includes(id))
            this.changeState("selected", selected.filter(it => it !== id));
        else
            this.changeState("selected", [...selected, id]);
    }

    renderContent() {
        const { selected, children } = this.state;
        const { diagnosis } = this._config;

        return (
            <div className="teethDialog flex col gap16">

                <div className="blockDiagnosis">
                    {diagnosis?.map((it, i) => (!children || it.children) && (<div key={"diag" + i} className="diagCell flex">
                        {this.insertOvalText({
                            text: it.title,
                            select: selected.includes(it.id),
                            onClick: this.onClickOvalText.bind(this, it.id)
                        })}
                    </div>))}
                </div>
            </div>
        );
    }
}

